export var DOMAIN_STORAGE_KEY = 'fisherman-daysmart-checkout-domain';
export var DOMAIN_TYPE_STORAGE_KEY = 'fisherman-daysmart-checkout-domain-type';
export var CHECKOUT_STEP_STORAGE_KEY = 'fisherman-daysmart-checkout-step';